module.exports = __webpack_public_path__ + "static/bg04-5a2a91edde2483466d2cfbc4e804b4e9.jpg";